import { useState } from 'react'

import { preconUserId } from 'environment'

import { useAppSelector } from 'redux/hooks'

import { FORMAT } from 'types/deck'

import PreconSelector from 'components/deckPage/misc/EmptyDeckLanding/PreconSelector'
import Modal from 'components/elements/Modal'
import Icon from 'components/elements/Icon'

import styles from './emptyDeckLanding.module.scss'

const FORMATS_WITH_PRECONSTRUCTED = [FORMAT.EDH]

const ImportFromPrecon = () => {
  const { format } = useAppSelector(state => state.deck)

  const [isOpen, setIsOpen] = useState(false)

  const handleClose = () => setIsOpen(false)

  if (!FORMATS_WITH_PRECONSTRUCTED.includes(format)) return null
  if (preconUserId === null) return null

  return (
    <>
      <Modal open={isOpen} onClose={handleClose} closeButton>
        <PreconSelector format={format} onClose={handleClose} />
      </Modal>

      {/* Explicitly NOT using the Modal's inbuilt trigger here because we need to be able to close from here */}
      <button className={styles.landingButton} onClick={() => setIsOpen(true)}>
        <Icon name="download" link style={{ color: '#0094f7' }} size="massive" />
        <h4>Preconstructed Decks</h4>
      </button>
    </>
  )
}

export default ImportFromPrecon
